
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class WPBaseCheckbox extends Vue {
  private state = false
}
